const VosSentiment = () => import('@/views/market/vos/Sentiment')
const FeedbackPositive = () => import('@/views/market/vos/FeedbackPositive')
const SocialListeningReport = () =>
    import('@/views/market/vos/SocialListeningReport')
// const FeedbackNegative = () => import('@/views/market/vos/FeedbackNegative')
const MarketVosSentimentObjective = () => import('@/views/market/vos/Objective')

const mainWidget = [
    {
        title: 'รายการเสียงด้านบวกจาก Stakeholder',
        path: '/admin/widget/:category/:widget_code(121)',
        component: FeedbackPositive,
    },
    // {
    //   title: 'รายการเสียงด้านลบจาก Stakeholder',
    //   path: '/admin/widget/:category/:widget_code(122)',
    //   component: FeedbackPositive
    // },
    {
        title:
            'สัดส่วน Sentiment ของ Stakeholder ปริมาณคำสนทนาของกลุ่ม Stakeholder',
        path: '/admin/widget/:category/:widget_code(123)',
        component: VosSentiment,
    },
    {
        title:
            'รายงานข้อมูลที่มีการกล่าวถึงจังหวัด และแหล่งท่องเที่ยวในระบบ Social Listening (ข้อมูลตั้งแต่ 1 ธันวาคม 2563)',
        path: '/admin/widget/:category/:widget_code(123.1)',
        component: SocialListeningReport,
    },
    {
        title: 'ความมุ่งหมายของคำสนทนา ของ Stakeholder',
        path: '/admin/widget/:category/:widget_code(124)',
        component: MarketVosSentimentObjective,
    },
]

export default mainWidget.map(data => {
    const { path, title, component, redirect, children } = data

    return {
        path: path,
        name: title,
        component: component,
        redirect: redirect,
        meta: {
            title: title,
            requiresAuth: true,
            breadcrumb: title,
        },
        children: children,
    }
})
